
import React, { useEffect, useState, useRef } from "react";
import API from "../Services/Location";

const CenterModal = ({ onSelectCenter, type, locationId, resetTrigger }) => {

    const [location, setLocation] = useState([]);
    const [selected, setSelected] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [error, setError] = useState({});
    const hasFetched = useRef(false);
    const isFetched = useRef(false);
    useEffect(() => {
        setSelected(new Array(location.length).fill(false));
        setSelectAll(false);
        setError({});
        onSelectCenter([]);
    }, [resetTrigger, location.length]);

    useEffect(() => {
        if (!isFetched.current) {
            const companyId = localStorage.getItem("company_id");
            if (!companyId) {
                setError({ locationId: "No company ID found in localStorage." });
                return;
            }
            isFetched.current = true;
        }
        if (!hasFetched.current) {
            hasFetched.current = true;
            bindLocation(1, 0);
        }
    }, []);

    const bindLocation = async (is_active, limit) => {
        try {
            const payload = { is_active, limit };
            const response = await API.getLocationList(payload);
            const locations = (response?.data?.data || []).map(loc => ({
                ...loc,
                id: Number(loc.id),
            }));
            setLocation(locations);
            setSelected(new Array(locations.length).fill(false));
        } catch (error) {
            setError({ locationId: error.message || "An error occurred." });
            if (error?.response?.status === 403) {
                window.location.replace("/Login");
            }
        }
    };

    useEffect(() => {
        if (type === "edit" && location.length > 0 && locationId) {
            const ids = Array.isArray(locationId)
                ? locationId.map(Number)
                : String(locationId).split(",").map(id => Number(id.trim()));

            const updatedSelected = location.map(loc => ids.includes(loc.id));
            setSelected(updatedSelected);
            setSelectAll(updatedSelected.every(val => val === true));
        }
    }, [location, locationId, type]);

    const handleCheckboxChange = (id) => {
        const index = location.findIndex(loc => loc.id === id);
        if (index !== -1) {
            const updated = [...selected];
            updated[index] = !updated[index];
            setSelected(updated);
            const allSelected = updated.length > 0 && updated.every(val => val === true);
            setSelectAll(allSelected);
        }
    };

    const handleSelectAll = (e) => {
        const checked = e.target.checked;
        setSelectAll(checked);
        setSelected(new Array(location.length).fill(checked));
    };

    const handleOk = () => {
        const selectedLocationIds = location
            .map((loc, index) => (selected[index] ? loc.id : null))
            .filter(id => id !== null);

        if (selectedLocationIds.length === 0) {
            setError({ locationId: "Please select at least one center." });
            return;
        }

        setError({});
        if (onSelectCenter) {
            onSelectCenter(selectedLocationIds);
        }
        setShowModal(false);
    };

    const handleReset = () => {
        setSelected(new Array(location.length).fill(false));
        setSelectAll(false);
    };
    const [showCloseTooltip, setShowCloseTooltip] = useState(false);

    return (
        <section>

            <label className="filter-label">
                Center <span style={{ color: "red" }}>*</span>
            </label>
            <div className="dropdown" style={{ backgroundColor: "white" }}>
                <button
                    className="btn dropdown-toggle text-start form-control"
                    type="button"
                    onClick={() => setShowModal(true)}
                >
                    {(() => {
                        const selectedLocations = location
                            .filter((_, index) => selected[index])
                            .map(loc => loc.name);
                        if (selectedLocations.length === 0) return "Select Centers";
                        if (selectedLocations.length === 1) return selectedLocations[0];
                        return `${selectedLocations[0]}... (+${selectedLocations.length - 1})`;
                    })()}
                </button>
                {error.locationId && (
                    <small className="text-danger">{error.locationId}</small>
                )}
            </div>

            {showModal && (
                <div
                    className="modal fade show d-block"
                    tabIndex={-1}
                    style={{ background: "rgba(0,0,0,0.5)" }}
                >
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Select Center</h5>
                                {showCloseTooltip && selected.filter(Boolean).length === 0 && (
                                    <div
                                        style={{
                                            position: "absolute",
                                            bottom: "120%",
                                            left: "50%",
                                            transform: "translateX(-50%)",
                                            backgroundColor: "#f8d7da",
                                            color: "#721c24",
                                            padding: "6px 10px",
                                            borderRadius: "4px",
                                            fontSize: "13px",
                                            whiteSpace: "nowrap",
                                            boxShadow: "0 0 5px rgba(0,0,0,0.1)",
                                            zIndex: 999,
                                        }}
                                    >
                                        Please select at least one center
                                    </div>
                                )}
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowModal(false)}
                                    onMouseEnter={() => setShowCloseTooltip(true)}
                                    onMouseLeave={() => setShowCloseTooltip(false)}
                                //disabled={selected.filter(Boolean).length === 0}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="container ms-3 me-2">
                                    <div className="row mb-2">
                                        <div className="col-md-3">
                                            <div className="form-check d-flex align-items-center">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="select-all"
                                                    checked={selectAll}
                                                    onChange={handleSelectAll}
                                                    style={{ boxShadow: "0 0 0 1px blue" }}
                                                />
                                                <label
                                                    htmlFor="select-all"
                                                    className="form-check-label ms-2"
                                                    style={{ userSelect: "none", cursor: "pointer" }}
                                                >
                                                    Select All
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        {location.map((loc, index) => (
                                            <div className="col-md-3 mb-2" key={loc.id}>
                                                <div className="form-check d-flex align-items-center">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        id={`loc-${index}`}
                                                        checked={!!selected[index]}
                                                        onChange={() => handleCheckboxChange(loc.id)}
                                                        style={{ boxShadow: "0 0 0 1px blue" }}
                                                    />
                                                    <label
                                                        htmlFor={`loc-${index}`}
                                                        className="form-check-label ms-2"
                                                        style={{ userSelect: "none", cursor: "pointer" }}
                                                    >
                                                        {loc.name}
                                                    </label>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <div style={{ position: "relative", display: "inline-block" }}>
                                    {showCloseTooltip && selected.filter(Boolean).length === 0 && (
                                        <div
                                            style={{
                                                position: "absolute",
                                                bottom: "120%",
                                                left: "50%",
                                                transform: "translateX(-50%)",
                                                backgroundColor: "#f8d7da",
                                                color: "#721c24",
                                                padding: "6px 10px",
                                                borderRadius: "4px",
                                                fontSize: "13px",
                                                whiteSpace: "nowrap",
                                                boxShadow: "0 0 5px rgba(0,0,0,0.1)",
                                                zIndex: 999,
                                            }}
                                        >
                                            Please select at least one center
                                        </div>
                                    )}
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={() => setShowModal(false)}
                                        onMouseEnter={() => setShowCloseTooltip(true)}
                                        onMouseLeave={() => setShowCloseTooltip(false)}
                                    // disabled={selected.filter(Boolean).length === 0}
                                    >Close</button>
                                </div>

                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleOk}
                                    disabled={selected.filter(Boolean).length === 0}
                                >
                                    Ok
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            )}
        </section>
    );
};

export default CenterModal;
